module.exports = __webpack_public_path__ + "assets/img/14b.ae05d457.jpg";